import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import { useId } from 'react';

export interface FormItemProps {
    dataInputName?: string;
    label?: ReactNode;
    required?: boolean;
    children: ReactNode;
    /** Font weight for label. Defaults to 'medium' */
    labelWeight?: 'medium' | 'semibold';
}
const FormItem = ({ label, children, dataInputName, required, labelWeight = 'medium' }: FormItemProps) => {
    const fallbackId = useId();
    const labelFontWeight = labelWeight === 'semibold' ? 'font-semibold' : 'font-medium';

    return (
        <div data-input-name={dataInputName}>
            <label
                className={clsx('block text-left text-base leading-6 text-neutral-900 capitalize', labelFontWeight)}
                htmlFor={fallbackId}
            >
                {label}
                {required && <span className="ml-1 text-red-500">*</span>}
            </label>
            <div className={clsx('relative', label && 'mt-2')} id={fallbackId}>
                {children}
            </div>
        </div>
    );
};

export default FormItem;
